<div class="h-screen flex overflow-hidden">
  <qwiko-dashboard-side-nav
    [(sideNavIsOpen)]="sideNavIsOpen"
  ></qwiko-dashboard-side-nav>
  <div class="flex-1">
    <qwiko-dashboard-top-nav [(sideNavIsOpen)]="sideNavIsOpen">
    </qwiko-dashboard-top-nav>
    <main
      class="h-svh max-w-6xl mx-auto overflow-y-auto pt-4 px-4 md:px-8 pb-40 md:pb-20"
    >
      <router-outlet></router-outlet>
    </main>
  </div>
</div>

<qwiko-dashboard-mobile-nav></qwiko-dashboard-mobile-nav>
